module.exports = __webpack_public_path__ + "static/media/pumpkin.95db2b37.png";